<script>
	export let type = 'button';
</script>

<style>
	button {
		display: inline-flex;
		align-items: center;
		overflow: hidden;
		height: 44px;
		padding: 0 8px;
		color: rgb(80, 80, 80);
		border-radius: 8px;
		background: transparent;
		border: 2px solid currentColor;
		margin: 0;
	}
</style>

<button on:click {type} {...$$restProps}><slot /></button>